import { render, staticRenderFns } from "./BusCommonMessageWhiteIpList.vue?vue&type=template&id=87174732&scoped=true&"
import script from "./BusCommonMessageWhiteIpList.vue?vue&type=script&lang=js&"
export * from "./BusCommonMessageWhiteIpList.vue?vue&type=script&lang=js&"
import style0 from "./BusCommonMessageWhiteIpList.vue?vue&type=style&index=0&id=87174732&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87174732",
  null
  
)

export default component.exports